<template>    
    <header class="masthead">
      <Background/>      
      <div class="container">        
        <a href="#portfolio" title="Ver Galería de Piñatas">
          <div class="fa-stack fa-5x fa-bounce col-12 mb-4" id="piniata-bounce">
            <img src="/src/assets/img/logo-pinhatas-may.svg" width="200" height="191"
            class="img-fluid mb-3" alt="Piñatas May" onmouseover="this.classList.add('fa-shake')" onmouseout="this.classList.remove('fa-shake')" />
            </div>                    
        <img src="/src/assets/img/dale-dale-a-la-diversión-resized.webp" fetchpriority="high" width="352" height="102"
            class="img-fluid mb-3" alt="Piñatas May"  />
            </a>
        <h1 class="masthead-subheading text-info mt-1">¡Bienvenido!</h1>
        <a class="btn btn-info btn-xl text-uppercase shadow" aria-label="Ir al catálogo de piñatas" href="#portfolio">Ver Catálogo</a>        
      </div>
    </header>
</template>
<script setup>
  import Background from '@/components/Background.vue';
</script>  
